import React from "react";

const FlatList = ({
  // data = Array(4).fill(1),
  data = [],
  renderItem = () => {},
  renderEmpty = () => {},
}) => {
  return data.length > 0
    ? data.map((item, key) => renderItem(item, key))
    : renderEmpty();
};

export default FlatList;
